















































import { Component, Vue, Prop, Watch, Ref } from "vue-property-decorator";
import ResepObatSvc from "@/services/ResepObat";

@Component
export default class BmhpItemRow extends Vue {
  @Prop() item: any;

  @Prop() index: number;

  @Ref() namaItem: HTMLInputElement;
  @Ref() qtyItem: HTMLInputElement;

  search = null;
  entries = [];
  isLoading = false;
  _timerId = null;
  selectedItem = null;

  mounted() {
    console.log("mounted row", this.item);
    this.adjustItem(this.item);

    setTimeout(() => {
      this.namaItem.focus();
    }, 200);
  }

  onItemBlur() {
    if (this.search != this.item.obat_nama) {
      this.search = this.item.obat_nama;
      console.log("beda search...", this.search, this.item.obat_nama);
    }
  }

  removeItem(index) {
    this.$emit("remove-item", index);
  }

  selectItem(val) {
    if (val) {
      this.item.obat_id = val.id;
      this.item.obat_nama = val.nama;
      this.item.qty_unit = val.satuan;
      this.item.harga = val.harga;

      this.qtyItem.focus();
    }
  }

  @Watch("search")
  changedSearch(val) {
    this.entries = [];

    clearTimeout(this._timerId);

    console.log("changed search", val);

    this._timerId = setTimeout(() => {
      if (
        this.search === null ||
        this.search.length < 3 ||
        this.search === this.item.obat_nama
      )
        return;

      this.isLoading = true;

      ResepObatSvc.getRefObat(val, "a")
        .then(res => {
          this.entries = res.data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    }, 300);
  }

  adjustItem(newVal) {
    if (newVal) {
      const item = {
        id: newVal.obat_id,
        nama: newVal.obat_nama,
        label: newVal.obat_nama,
        satuan: newVal.qty_uni,
        harga: newVal.harga
      };

      this.entries = [item];
      // this.entries.push(item);
      this.$nextTick(() => {
        this.selectedItem = item;
        // this.search = newVal.obat_nama;
      });
    } else {
      this.$nextTick(() => {
        this.selectedItem = "";
      });
      this.search = "";
      this.entries = [];
    }
  }

  @Watch("item")
  changedItem(newVal, oldVal) {
    console.log("changed bhmp item row", oldVal, newVal);

    this.adjustItem(newVal);
  }

  @Watch("selectedItem")
  changeSelectedItem(val) {
    console.log("change selected item", val);
  }

  @Watch("entries")
  changeEntries(val) {
    console.log("change entries", val);
  }

  emitSave() {
    this.$emit("emit-save");
  }

  emitTab() {
    this.$emit("emit-tab");
  }
}
